import ProveedorList from './ProveedorList'
export {ProveedorList}
export default ProveedorList
